import mixpanel from "mixpanel-browser"
import { FullStory, isInitialized } from "@fullstory/browser"

export type AnalyticsProps = Record<string, unknown>

/**
 * Fire an analytics event to BOTH Mixpanel and FullStory. Event names and
 * payloads mirror backflip-mobile's `track()` sink so the dashboards line up.
 * SSR-safe and best-effort (a missing/uninitialised SDK is ignored). Identity is
 * attached by the query-client subscriber, so events inherit the signed-in user.
 */
export const track = (name: string, properties: AnalyticsProps = {}): void => {
  if (typeof window === "undefined") return
  try {
    mixpanel.track(name, properties)
  } catch {
    // Mixpanel not initialised / blocked — ignore.
  }
  try {
    if (isInitialized()) {
      FullStory("trackEvent", { name, properties })
    }
  } catch {
    // FullStory not ready — ignore.
  }
}
